<script>
import api from '@/utils/api'
import ApiErrorMixin from '@/mixins/apiErrorMixin'
import AppConfig from '@/utils/settings'

export default {
  name: 'BankMixin',
  mixins: [ApiErrorMixin],
  methods: {
    async getBank (bik) {
      const requestResponse = await api.loadOne(`${AppConfig.getEnvParameter('BIK_PATH')}?search[title]=${bik}`)
      if (requestResponse) {
        const response = this.checkApiResponse(requestResponse)
        return response
      } else {
        return null
      }
    }
  }
}
</script>
